import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { format } from "date-fns";

function UserPaymentsByDay() {
  const { brand, dayKey } = useParams();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const total = orders.reduce((sum, o) => sum + parseFloat(o.brandPrice || "0"), 0);
  const malidag = orders.reduce(
    (sum, o) => sum + (parseFloat(o.price || "0") - parseFloat(o.brandPrice || "0")),
    0
  );

  const getOrderDate = (order) => {
    return new Date(order.timestamp || order.createdAt || Date.now());
  };

  const getUniqueId = (order) => {
    return (
      order.transactionHash ||
      order.paypalOrderId ||
      order.paypalCaptureId ||
      order._id
    );
  };

  const getExplorerLink = (order) => {
    if (order.paymentMethod !== "crypto" || !order.transactionHash) {
      return null;
    }

    switch (Number(order.chainId)) {
      case 1:
        return `https://etherscan.io/tx/${order.transactionHash}`;
      case 56:
        return `https://bscscan.com/tx/${order.transactionHash}`;
      case 97:
        return `https://testnet.bscscan.com/tx/${order.transactionHash}`;
      case 137:
        return `https://polygonscan.com/tx/${order.transactionHash}`;
      default:
        return null;
    }
  };

  const getPaymentLabel = (order) => {
    if (order.paymentMethod === "crypto") {
      return `${order.amount} ${order.cryptoSymbol || order.currency || ""}`;
    }

    if (order.paymentMethod === "paypal") {
      return `${order.amount} ${order.currency || ""} via PayPal`;
    }

    return `${order.amount} ${order.currency || ""}`;
  };

  useEffect(() => {
    fetch("https://api.malidag.com/api/orders-all")
      .then((res) => res.json())
      .then((data) => {
        const filtered = (Array.isArray(data) ? data : []).filter((order) => {
          if (!order.brand) return false;

          const parsedDate = getOrderDate(order);
          if (isNaN(parsedDate)) return false;

          const orderDate = format(parsedDate, "yyyy-MM-dd");

          return (
            order.brand.toLowerCase() === brand.toLowerCase() &&
            orderDate === dayKey
          );
        });

        setOrders(filtered);
        console.log("Filtered:", filtered);
        console.log("Brand:", brand, "DayKey:", dayKey);
      })
      .catch((err) => console.error("Failed to fetch orders:", err))
      .finally(() => setLoading(false));
  }, [brand, dayKey]);

  if (loading) return <p>Loading day data...</p>;
  if (!orders.length) return <p>No orders found for {dayKey}.</p>;

  return (
    <div style={{ padding: "1rem" }}>
      <h2>{brand.toUpperCase()} Orders for {dayKey}</h2>

      <p>
        Total: ${total.toFixed(2)}{" "}
        <span style={{ color: "#555", fontStyle: "italic" }}>
          (Malidag: ${malidag.toFixed(2)})
        </span>
      </p>

      <p>🧾 {orders.length} orders</p>

      <ul>
        {orders.map((order, index) => {
          const time = getOrderDate(order).toLocaleTimeString();
          const explorerLink = getExplorerLink(order);
          const uniqueId = getUniqueId(order);

          return (
            <li key={uniqueId || index} style={{ marginBottom: "0.75rem" }}>
              <div>
                <strong>{order.fullName}</strong> ({order.email}) at <em>{time}</em>
              </div>

              <div>
                Paid {getPaymentLabel(order)} — BrandPrice:{" "}
                <strong>${parseFloat(order.brandPrice || 0).toFixed(2)}</strong>, price:{" "}
                <strong>${parseFloat(order.price || 0).toFixed(2)}</strong>
              </div>

              <div>
                {explorerLink ? (
                  <>
                    Tx:{" "}
                    <a href={explorerLink} target="_blank" rel="noopener noreferrer">
                      {order.transactionHash.slice(0, 12)}...
                    </a>
                  </>
                ) : order.paymentMethod === "paypal" ? (
                  <>
                    PayPal Ref:{" "}
                    <span>
                      {(order.paypalOrderId || order.paypalCaptureId || "N/A").slice(0, 12)}...
                    </span>
                  </>
                ) : (
                  <>Ref: {uniqueId || "N/A"}</>
                )}

                <Link
                  to={`/user-payment-details/${uniqueId}`}
                  state={{ order }}
                  style={{ marginLeft: "10px", textDecoration: "underline", color: "blue" }}
                >
                  View Item Info
                </Link>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default UserPaymentsByDay;